export * from './fullscreen.component';
